import { LOGIN_HEADER_KEY } from '../../../APIConstants';
import { awExternalPicklistApi } from '../Base';
import { UserInfo } from '../models';
import { DecodesParams, ExternalPickList } from '../models/ExternalPickList';
import { ExternalPicklistTypeEnum } from '../models/ExternalPicklistEnum';

export const externalPickListPath = 'api/v1/aperio/decodes';

export async function getExternalPickList<T = ExternalPickList>(
  type: string,
  userInfo: UserInfo,
  decodesParams: DecodesParams
): Promise<T> {
  const {
    firmId,
    teamId,
    longShortStrategy,
    portfolioMargin,
    longShortScope,
    taxableAccount,
    factortiltName,
    custodian,
    productType,
  } = decodesParams;
  const isFactorTilt = type === ExternalPicklistTypeEnum.FactorTilt;
  const isTiltImportance = type === ExternalPicklistTypeEnum.TiltImportanceOption;
  const isAccount = type === ExternalPicklistTypeEnum.Account;
  const isStrategy = type === ExternalPicklistTypeEnum.Strategy;

  try {
    const externalPickList = await awExternalPicklistApi.get<T>(externalPickListPath, {
      params: {
        entityType: type,
        firmId,
        teamId,
        ...((isFactorTilt || isTiltImportance) && { longShortStrategy }),
        ...(isFactorTilt && { portfolioMargin, longShortScope }),
        ...(isTiltImportance && { taxableAccount, factortiltName }),
        ...(isAccount && productType && { productType }),
        ...(isStrategy && { custodian }),
      },
      headers: {
        [LOGIN_HEADER_KEY]: userInfo.login,
      },
    });
    return externalPickList?.data;
  } catch (error) {
    return {} as T;
  }
}
